import React from 'react'

import * as dateLib from '../../../libraries/date'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = {
  startDate: Date,
  endDate: Date,
  children: React.ReactNode | React.ReactNode[]
  fixedHeight?: boolean
  showEndDate?: boolean
  leftColWidth?: string
}
const DateRow: React.FC<Props> = ({ startDate, endDate, children, fixedHeight = true, showEndDate = true, leftColWidth = 'w-24 md:w-36' }) => {
  const { currentLanguage } = useI18N()
  let containerColor = 'text-black'
  if (new Date(endDate) < new Date()) {
    containerColor = `${containerColor} grayscale opacity-80`
  }

  return (
    <div className={`flex items-stretch bg-white rounded-lg ${fixedHeight ? 'h-34 sm:h-28' : ''} ${containerColor}`}>
      <div className={`${leftColWidth} sm:m-0 sm:px-1 py-3 text-center rounded-lg rounded-r-none sm:rounded-l-lg flex flex-col sm:justify-center bg-soft-green`}>
        <p className='leading-none'><span className='m-0 text-2xl md:text-4xl font-semibold'>{dateLib.getDayOfMonth(startDate)}</span></p>
        <p><span className='text-2xs md:text-sm font-semibold'>{dateLib.getMonthName(startDate, currentLanguage)}</span></p>
        <p className='text-2xs sm:text-xs'>{dateLib.getHoursAndMinutes(startDate, currentLanguage)} {showEndDate ? `- ${dateLib.getHoursAndMinutes(endDate, currentLanguage)}` : ''}</p>
      </div>
      <div className='flex-1 rounded-r-lg p-3 sm:pl-7'>
        {children}
      </div>
    </div>
  )
}

export default DateRow
